var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"36","height":"36","rx":"8","fill":"#6366F1","key":0}),React.createElement("circle",{"cx":"18","cy":"18","r":"12","fill":"#F9FAFB","key":1}),React.createElement("rect",{"x":"12","y":"12","width":"2","height":"5","fill":"#4F46E5","key":2}),React.createElement("rect",{"x":"20","y":"14","width":"5","height":"2","fill":"#4F46E5","key":3}),React.createElement("path",{"d":"M14 21H22V21C22 23.2091 20.2091 25 18 25V25C15.7909 25 14 23.2091 14 21V21Z","fill":"#4F46E5","key":4})]);
}

LogoIcon.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
